import React, { useEffect, useRef } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSettings } = FiIcons;

/* global ZFAdvLead, zfutm_zfAdvLead, ZFLead, zfutm_zfLead */

const Settings = () => {
  const formDivRef = useRef(null);

  useEffect(() => {
    const formContainer = formDivRef.current;
    if (!formContainer || formContainer.querySelector('iframe')) {
      return;
    }

    const messageHandler = (event) => {
      const evntData = event.data;
      if (evntData && evntData.constructor === String) {
        const zf_ifrm_data = evntData.split("|");
        if (zf_ifrm_data.length === 2 || zf_ifrm_data.length === 3) {
          const zf_perma = zf_ifrm_data[0];
          const zf_ifrm_ht_nw = (parseInt(zf_ifrm_data[1], 10) + 15) + "px";
          const iframe = formContainer.getElementsByTagName("iframe")[0];
          if (iframe && (iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(zf_perma) > 0) {
            const prevIframeHeight = iframe.style.height;
            let zf_tout = false;
            if (zf_ifrm_data.length === 3) {
              iframe.scrollIntoView();
              zf_tout = true;
            }
            if (prevIframeHeight !== zf_ifrm_ht_nw) {
              if (zf_tout) {
                setTimeout(function () {
                  iframe.style.height = zf_ifrm_ht_nw;
                }, 500);
              } else {
                iframe.style.height = zf_ifrm_ht_nw;
              }
            }
          }
        }
      }
    };

    try {
      const f = document.createElement("iframe");
      let ifrmSrc = 'https://forms.zohopublic.com/Prosomo/form/BloggingBotAi/formperma/bilVlZQ8xtD3hHm4iDww1JF4z4Wqm035OPjY1hygHlY?zf_rszfm=1';
      
      try {
        if (typeof ZFAdvLead !== "undefined" && typeof zfutm_zfAdvLead !== "undefined") {
          for (let prmIdx = 0; prmIdx < ZFAdvLead.utmPNameArr.length; prmIdx++) {
            let utmPm = ZFAdvLead.utmPNameArr[prmIdx];
            utmPm = (ZFAdvLead.isSameDomian && (ZFAdvLead.utmcustPNameArr.indexOf(utmPm) === -1)) ? "zf_" + utmPm : utmPm;
            const utmVal = zfutm_zfAdvLead.zfautm_gC_enc(ZFAdvLead.utmPNameArr[prmIdx]);
            if (typeof utmVal !== "undefined" && utmVal !== "") {
              ifrmSrc += (ifrmSrc.indexOf('?') > 0 ? '&' : '?') + utmPm + '=' + utmVal;
            }
          }
        }
        if (typeof ZFLead !== "undefined" && typeof zfutm_zfLead !== "undefined") {
          for (let prmIdx = 0; prmIdx < ZFLead.utmPNameArr.length; prmIdx++) {
            const utmPm = ZFLead.utmPNameArr[prmIdx];
            const utmVal = zfutm_zfLead.zfutm_gC_enc(ZFLead.utmPNameArr[prmIdx]);
            if (typeof utmVal !== "undefined" && utmVal !== "") {
              ifrmSrc += (ifrmSrc.indexOf('?') > 0 ? '&' : '?') + utmPm + '=' + utmVal;
            }
          }
        }
      } catch (e) {
        // Tracking can fail silently
      }

      f.src = ifrmSrc;
      f.style.border = "none";
      f.style.height = "150px";
      f.style.width = "90%";
      f.style.transition = "all 0.5s ease";
      f.setAttribute("aria-label", 'Blogging Bot - Ai');
      formContainer.appendChild(f);
      window.addEventListener('message', messageHandler, false);
    } catch (e) {
      // Main form embedding logic can fail gracefully
    }

    return () => {
      window.removeEventListener('message', messageHandler, false);
      if (formContainer) {
        formContainer.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className="max-w-6xl mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h1 className="text-3xl font-bold text-gray-900 flex items-center space-x-3 mb-6">
          <SafeIcon icon={FiSettings} className="text-2xl text-blue-600" />
          <span>Settings</span>
        </h1>
        <div id="zf_div_bilVlZQ8xtD3hHm4iDww1JF4z4Wqm035OPjY1hygHlY" ref={formDivRef} className="w-full">
          {/* Zoho form iframe will be injected here */}
        </div>
      </div>
    </div>
  );
};

export default Settings;